/*
    Both regexps are taken from NetSuite and should be used for consistency in email validation
    between AMAX and NetSuite
*/
export const netSuiteEmailQuotesRegex = /\s|[,":<>]/;
export const netSuiteEmailRegex =
    /^[-a-zA-Z0-9!#$%&'*+/=?^_`{|}~]+(?:\.[-a-zA-Z0-9!#$%&'*+/=?^_`{|}~]+)*@(?:[a-zA-Z0-9]+(?:-+[a-zA-Z0-9]+)*\.)+(?:xn--[-a-zA-Z0-9]+|[a-zA-Z]{2,16})$/i;
